import React, { useState, useEffect } from "react";
import { manrope } from "@/ui/fonts";
import {
  Dialog,
  IconButton,
  DialogHeader,
  Typography,
} from "@material-tailwind/react";
import Image from "next/image";
import DepartmentSelect from "../ciudadesColombia/DepartmentSelect";
import CitySelect from "../ciudadesColombia/CitySelect";
import EmptyField from "../ciudadesColombia/EmptyField";
import CheckBox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Turnstile from "react-turnstile";
import PhoneInputComponent from "./Inputs/PhoneInput";
import SelectInput from "./Inputs/SelectInput";

export function CryptoModal() {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState("")
  const [formData, setFormData] = useState({
    name: "",
    surname: "",
    email: "",
    idNumber: "",
    phone: "",
    department: "",
    city: "",
    birthdate: "",
    whereYouKnow: "",
    acceptTerms: false,
  });
  const [departmentId, setId] = useState(0);
  const [token, setToken] = useState("");
  const [color, setColor] = useState("text-red-500");


  useEffect(() => {
    if (window.location.pathname === "/") {
      const timer = setTimeout(() => {
        setOpen(true)
      }, 5000)
      return () => clearTimeout(timer)
    } else {
      return
    }
  }, [])

  useEffect(() => {
    if (message !== "") {
      const timer = setTimeout(() => {
        setMessage("")
      }, 5000)
      return () => clearTimeout(timer)
    }
  }, [message])

  const handleOpen = () => setOpen((cur) => !cur);

  const handlePhoneChange = (value) => {
    setFormData({
      ...formData,
      phone: value, // Directly update the phone field
    });
  };

  const handleSelectChange = (value) => {
    setFormData({
      ...formData,
      whereYouKnow: value, // Directly update the phone field
    });
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleDepartmentChange = (department, department_id) => {
    setId(department_id);
    setFormData((prevState) => ({
      ...prevState,
      department,
    }));
  };

  const handleCityChange = (city) => {
    setFormData((prevState) => ({
      ...prevState,
      city,
    }));
  };

  const formatDateForSheets = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // January is 0!
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  const isFormValid = () => {
    return Object.values(formData).every(field => {
      if (typeof field === 'string') {
        return field.trim() !== ''; // For string values, check if it's not empty
      }
      return field !== ''; // For non-string values, just check if it's not empty or false
    }) && formData.acceptTerms; // Make sure `acceptTerms` is true
  };
  

  const handleOnSubmit = async (e) => {
    setLoading(true)
    e.preventDefault();

    const submissionData = {
      ...formData,
      token,
    };

    // Fetch existing data from Google Sheets
    const sheetUrl = "https://sheetdb.io/api/v1/cae54qhane5xk"
    let existingEntries = [];
    
    try {
      const response = await fetch(sheetUrl);
      if (response.ok) {
        existingEntries = await response.json();
      } else {
        console.error("Failed to fetch existing entries");
        throw new Error("Failed to get data")
      }
    } catch (error) {
      console.error("Error fetching existing entries:", error);
      setMessage("Hubo un error guardando tu suscripcion")
      return;
    }
    
    // Check if email is already registered
    const emailExists = existingEntries.some(entry => entry["Correo electrónico"] === formData.email);
    
    if (emailExists) {
      //alert("Tú ya te inscribiste al concurso");
      setColor("text-red-500")
      setMessage("Tus datos ya han sido registrados.");
      setFormData({
        name: "",
        surname: "",
        email: "",
        idNumber: "",
        phone: "",
        department: "",
        city: "",
        birthdate: "",
        whereYouKnow: "",
        acceptTerms: false,
      })
      setLoading(false)
      return;
    }

    // Send to Google Sheets if email is not found
  const formattedBirthday = formatDateForSheets(formData.birthdate);
  const data = {
    data: [{
      "Nombres": formData.name,
      "Apellidos": formData.surname,
      "Número de identificación": formData.idNumber,
      "Ciudad": formData.city,
      "Departamento": formData.department,
      "Correo electrónico": formData.email,
      "Celular": formData.phone,
      "Cumpleaños": formattedBirthday,
      "Dónde conociste Minca Electric": formData.whereYouKnow,
    }]
  };

  try {
    const response = await fetch(sheetUrl, {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    });

    if (response.ok) {
      const result = await response.json();
      console.log("Response from SheetDB:", result);
      // Send Email
      await fetch("/api/pop-up", {
        method: "POST",
        headers: {
          'Accept': 'application/json',
          "Content-Type": 'application/json'
        },
        body: JSON.stringify(formData)
      });
      setMessage("¡Ya estás participando!")
      setColor("text-[#22BB55]")
      setLoading(false)
      setFormData({
        name: "",
        surname: "",
        email: "",
        idNumber: "",
        phone: "",
        department: "",
        city: "",
        birthdate: "",
        whereYouKnow: "",
        acceptTerms: false,
      })
    } else {
      console.error("Failed to submit data");
      setMessage("Error al guardar tus datos")
      setLoading(false)
      setFormData({
        name: "",
        surname: "",
        email: "",
        idNumber: "",
        phone: "",
        department: "",
        city: "",
        birthdate: "",
        whereYouKnow: "",
        acceptTerms: false,
      })
    }
  } catch (error) {
    console.error("Error:", error);
    setMessage("Error al guardar tus datos")
    setLoading(false)
    setFormData({
        name: "",
        surname: "",
        email: "",
        idNumber: "",
        phone: "",
        department: "",
        city: "",
        birthdate: "",
        whereYouKnow: "",
        acceptTerms: false,
      })
  }

    console.log("Form submitted: ", submissionData);
    // You can further handle the data, such as sending it to a backend server.
  };

  return (
    <div className="">
      <button
        className="flex-none rounded-full bg-black px-3.5 py-1 text-sm font-semibold text-white shadow-sm hover:bg-[#42454A] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900"
        onClick={handleOpen}
      >
        Participa Ahora <span aria-hidden="true">&rarr;</span>
      </button>
      <Dialog
        id="popup"
        className="w-[90%] lg:w-[50%] overflow-auto h-[90%] mt-[25px] !rounded-[10px]"
        dismiss={{
          color: "transparent",
        }}
        open={open}
        color="transparent"
        handler={handleOpen}
      >
        <DialogHeader className="justify-between p-4 lg:p-16">
          <div>
            <Image
              alt="imgPopUp"
              src="https://test.mincaelectric.com/wp-content/uploads/2025/05/sorteo-minca-electric-1600w.webp"
              width={200}
              height={165}
              className="flex w-[130px] h-[174px] lg:w-[160px] lg:h-[204px] justify-center items-center mx-auto"
            />
            <Typography variant="h5" className={`text-center text-[32px] uppercase`} color="black">
              ¡Gana una Minca 1600w GRATIS!
            </Typography>
            <Typography color="gray" className="text-center text-[16px] lg:text-[20px] leading-[30px] lg:leading-[30px] w-[90%] ml-4 lg:ml-10" variant="paragraph">
              Regístrate y síguenos en todas nuestras redes sociales. Tendrás la
              oportunidad de <span className="font-semibold">ganar un scooter eléctrico Minca 1600w GRATIS</span> por
              un valor de <span className="font-bold bg-emerald-100 text-emerald-700 px-1 py-0.5">$5.300.000 COP</span>
            </Typography>
          </div>
            <svg
            onClick={handleOpen}
              xmlns="https://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
              className="h-5 w-5 absolute top-4 right-4 text-black"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
        </DialogHeader>
        <div className="bg-gray-200 rounded-b-[10px] h-[450px] lg:h-[450px] p-4">
          <form className="overflow-y-auto overflow-x-hidden mb-6 mx-[-16px] lg:mx-[-16px] p-4 lg:px-12 lg:py-16 bg-gray-200" onSubmit={handleOnSubmit}>
            <div className="grid grid-cols1 lg:grid-cols-2 gap-8">
              <div className="">
                <label htmlFor="name" className={`${manrope.className} text-base font-semibold text-[#111]`}>
                  Nombres <span className="text-red-700">*</span>
                </label>
                <input
                  id="name"
                  name="name"
                  type="text"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="border-gray-900 rounded-[10px] p-4 w-full"
                />
              </div>
              <div>
                <label htmlFor="surname" className={`${manrope.className} text-base font-semibold text-[#111]`}>
                  Apellidos <span className="text-red-700">*</span>
                </label>
                <input
                  id="surname"
                  name="surname"
                  type="text"
                  value={formData.surname}
                  onChange={handleChange}
                  required
                  className="border-gray-900 rounded-[10px] p-4 w-full"
                />
              </div>
            </div>
            <div className="mt-4">
              <label htmlFor="email" className={`${manrope.className} text-base font-semibold text-[#111]`}>
                Correo electrónico <span className="text-red-700">*</span>
              </label>
              <input
                id="email"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="border-gray-900 rounded-[10px] p-4 w-full"
              />
            </div>
            <div className="mt-4">
              <label htmlFor="idNumber" className={`${manrope.className} text-base font-semibold text-[#111]`}>
                Número de identificación <span className="text-red-700">*</span>
              </label>
              <input
                id="idNumber"
                name="idNumber"
                type="text"
                value={formData.idNumber}
                onChange={handleChange}
                required
                className="border-gray-900 rounded-[10px] p-4 w-full"
              />
            </div>
            <div className="mt-4">
              <label htmlFor="phone" className={`${manrope.className} text-base font-semibold text-[#111]`}>
                Teléfono <span className="text-red-700">*</span>
              </label>
              <PhoneInputComponent value={formData.phone} onChange={(value) => handlePhoneChange(value)} />
            </div>
            <div className="mt-4 grid grid-cols1 lg:grid-cols-2 lg:gap-4">
              <div>
                <label htmlFor="department" className={`${manrope.className} text-base font-semibold text-[#111]`}>
                  Departamento <span className="text-red-700">*</span>
                </label>
                <DepartmentSelect style={{height: "60px", borderColor: "none", rounded: "10px"}} onChange={handleDepartmentChange} />
              </div>
              <div className="">
                <label htmlFor="city" className={`${manrope.className} text-base font-semibold text-[#111]`}>
                  Municipio <span className="text-red-700">*</span>
                </label>
                {!formData.department && <EmptyField style={{height: "60px", borderColor: "none", rounded: "10px"}} />}
                {formData.department && <CitySelect style={{height: "60px", borderColor: "none", rounded: "10px"}} department_id={departmentId} onChange={handleCityChange} />}
              </div>
            </div>
            <div className=" mt-4 grid grid-cols1 lg:grid-cols-2 gap-4">

            <div className="relative">
              <label
                htmlFor="birthdate"
                className={`${manrope.className} text-base font-semibold text-[#111]`}
              >
                Fecha de nacimiento <span className="text-red-700">*</span>
              </label>

              <input
                id="birthdate"
                name="birthdate"
                type="date"
                value={formData.birthdate}
                onChange={handleChange}
                required
                className="border-gray-900 rounded-[10px] px-4 py-4 h-[60px] w-full appearance-none"
              />

              {/* Placeholder span only visible on mobile screens */}
              <span
                className="absolute left-4 top-[50%] text-gray-500 pointer-events-none transition-all lg:hidden flex items-center" // Only for mobile
                id="date-placeholder"
              >
                {!formData.birthdate &&
                  "mm/dd/yyyy"
                }
              </span>
            </div>

            <div className='border-gray-200'>
                  <label
                    htmlFor="whereYouKnow"
                    className={`${manrope.className} text-base font-semibold text-[#111]`}
                  >
                    {" "}
                    ¿Dónde conociste Minca Electric? <span className="text-red-700">*</span>{" "}
                  </label>
                  <SelectInput onChange={(value) => handleSelectChange(value)} />
                </div>
              </div>
            <div className="">
              <FormControlLabel
                control={
                  <CheckBox
                    checked={formData.acceptTerms}
                    onChange={handleChange}
                    color="default"
                    name="acceptTerms"
                    className="rounded-[50%]"
                  />
                }
                label={
                  <Typography color="gray" variant="paragraph" className="text-md mt-[50px] font-semibold">
                    Aplica <a href="/Terminos_y_condiciones_sorteo_2025" className="underline">Términos y condiciones.<span className="text-red-700">*</span></a>
                    <br />
                    <div className="w-[80%]">
                      <span className="text-[16px] text-black">La inscripción se cerrará el 15 de julio de 2025 y el sorteo se llevará a cabo el 17 de julio de 2025.</span>
                    </div>
                  </Typography>
                }
              />
            </div>
            <div className="my-4">
            <Turnstile
                  className="mt-8"
                  sitekey={"0x4AAAAAAAfSIStnzLkKHqq_" ?? ""}
                  onVerify={(token) => setToken(token)}
              />
            </div>

              <div>
                <span className={`${color}`}>{message}</span>
              </div>

            {isFormValid() && !loading ? (
                <button
                    type="button"
                    onClick={handleOnSubmit}
                    className="inline-flex w-full justify-center rounded-[20px] bg-black px-8 py-4 my-4 text-[16px] font-semibold text-white shadow-sm hover:bg-gray-400 sm:ml-3 sm:w-auto"
                    >
                    Registrar mis datos 
                </button>
                ) : (
                    <button
                    type="button"
                    disabled
                    className="inline-flex w-full justify-center rounded-full bg-gray-400 px-8 py-2 my-8 text-[16px] font-semibold text-black shadow-sm sm:w-auto"
                    >
                    Registrar mis datos 
                </button>
                )
            }
          </form>
        </div>
      </Dialog>
    </div>
  );
}

export default CryptoModal;
